<template>
    <div>
        <div class="company-job bg-orange-100 rounded-lg px-6 mb-15">
            <div class="flex mb-0 md:mb-0 pt-4">
                <h2 class="text-2xl md:leading-13">
                    {{ t('job_widget.recent') }}
                </h2>
                <!-- native modifier has been removed, please confirm whether the function has been affected  -->
                <Btn
                    v-show="screen.minMD && userHasJobVibe"
                    :href="route('career.corner.index')"
                    target="_blank"
                    class="company-button ml-auto"
                    :variant="BtnVariant.OUTLINED"
                    color="primary"
                    :label="t('job_widget.button')"
                    :data-click="`job widget,${route('career.corner.index')}`"
                    @click="storeJobSeekerStatus()"
                />
            </div>
            <div class="mt-4">
                <JobList
                    :job-list="jobs"
                    :progress="false"
                    :can-load-more="false"
                    company-profile-widget
                    @application-interest-clicked="storeJobSeekerStatus()"
                />
            </div>
        </div>
    </div>
</template>

<script>
import route from '@router/route';
import { mapGetters } from 'vuex';
import JobSeekerMixin from '@/mixins/jobSeekerMixin';
import { BtnVariant } from '@components/Btn';
import JobList from '@components/CareerCornerMatching/JobList.vue';
import { trackClick } from '@/modules/tracking';
import { useTranslation } from 'i18next-vue';

export default {
    name: 'CompanyShowJobWidget',
    components: { JobList },
    extends: JobSeekerMixin,
    props: {
        companyId: {
            type: Number,
            required: true,
        },
    },
    setup() {
        const { t } = useTranslation('company');
        return { t };
    },
    data() {
        return {
            BtnVariant,
            limit: 3,
        };
    },
    computed: {
        ...mapGetters({
            locale: 'ui/getLocale',
            jobs: 'careerCorner/companyJobs',
            screen: 'ui/screen',
            userHasJobVibe: 'careerCorner/userHasJobVibe',
        }),
    },
    methods: {
        route,
        track(table, value) {
            trackClick(table, {
                page_field_name: 'Company Profile Job Widget',
                page_field_value: value,
                page_field_type: 'button',
            });
            this.storeJobSeekerStatus();
        },
    },
};
</script>

<style lang="scss" scoped>
.ml-4 {
    word-break: break-word;
    hyphens: auto;
}

.company-job {
    .company-button {
        height: 48px;
    }
    .company-container-image {
        width: 96px;
        min-width: 96px;
        height: 96px;

        .company-image {
            width: 80px;
            height: 80px;
        }
    }
}
</style>
